// Grid-connector corner marks (Figma "Grid Connectors", grey-950). Top corners
// use the 1px `GridTee` glyph (same weight as `/press-room`); bottom corners
// keep the `direction` L brackets. Desktop only — the article is full-bleed
// below `lg`. Parent must be relative.

import {
  GRID_ELBOW_FRAME_BOTTOM_LEFT,
  GRID_ELBOW_FRAME_BOTTOM_RIGHT,
  GRID_TEE_TOP_LEFT,
  GRID_TEE_TOP_RIGHT,
  GridElbow,
  GridTee,
} from "@/components/ui/grid-connector";
import { cn } from "@/lib/utils";

export function StoryCornerMarks() {
  const base = "z-10 hidden lg:block";
  return (
    <>
      {/* Top ⊤ marks — 1px GridTee (not GridConnector `end` @ 1.5px) so weight
          matches press-room listing rails. Junction at viewBox x=3.5 / y=0.5. */}
      <GridTee className={cn(GRID_TEE_TOP_LEFT, base)} />
      <GridTee className={cn(GRID_TEE_TOP_RIGHT, base)} />
      {/* Bottom └ / ┘ — stem/arm join on the same vertical edge as the tees. */}
      <GridElbow
        corner="bottom-left"
        className={cn(GRID_ELBOW_FRAME_BOTTOM_LEFT, base)}
      />
      <GridElbow
        corner="bottom-right"
        className={cn(GRID_ELBOW_FRAME_BOTTOM_RIGHT, base)}
      />
    </>
  );
}
